/*
TYpes to account for:
  custom
  apply-for-credit
  contact-dealer

  // Ones that need you to select a dealer first:
  dealer-site
  live-chat
  GXP
*/
// maps to the data-destination value that is output in DOM

export default {
  dealerSite: 'dealer-site',
  dealerDirections: 'map-dealer',
  dealerChat: 'live-chat',
  compare: 'compare-vehicles',
  raq: 'request-a-quote',
  inventory: 'inventory',
  dealBuilder: 'deal-builder',
  offers: 'offers',
  chat: 'live-chat', // not yet in use
  gxp: 'gxp', // not yet in use
  dealerSearchInventory: 'dealer-inventory'
};
